import {
  VALIDATIONS,
  SHOWBUTTONNAVIGATION,
  ORDERFROMTRACKING
} from "../Types";

const initialState = {
  validations: null,
  showButtonNavigation: true,
  orderFromTracking: false
}

export const publicReducer = (state = initialState, action) => {
  switch (action.type) {
    case VALIDATIONS: {
      return {
        ...state,
        validations: action.payload,
      };
    }
    case SHOWBUTTONNAVIGATION: {
      return {
        ...state,
        showButtonNavigation: action.payload,
      };
    }
    case ORDERFROMTRACKING: {
      return {
        ...state,
        orderFromTracking: action.payload,
      };
    }
    default:
      return state;
  }
};
